var projectTimeline = {
	"Project timeline": "プロジェクトのタイムライン",
	"None planned": "計画なし",
	"1-3 months": "1～3 か月",
	"4-6 months": "4～6 か月",
	"7-12 months": "7～12 か月",
	"More than 1 year": "1 年超"
};

export { projectTimeline as default };
